import axios from 'axios'
import { AccountInterface } from 'client/Interfaces/AccountsInterface'

import { getRequestConfig } from './index'

export const getAccounts = async (): Promise<AccountInterface[]> => {
  const response = await axios.get<AccountInterface[]>('/platform/v4/account', getRequestConfig())
  return response.data
}
